module.exports = __webpack_public_path__ + "img/lg_ring_y_s_0_1.7e4c94a9.png";